import EmberRouter from '@ember/routing/router';
import config from 'tio-employee/config/environment';
import ENV from 'tio-employee/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('freestyle');
  this.route('welcome');
  this.route('login');
  this.route('auth-by-token');
  this.route('auth-failed');
  this.route('logout');
  this.route('logged-out');
  this.route('enroll');
  this.route('register', function () {
    this.route('index', { path: '/' });
    this.route('confirmation');
  });
  this.route('forgot-password', function () {
    this.route('index', { path: '/' });
    this.route('confirmation');
  });
  this.route('reset-password', function () {
    this.route('index', { path: '/' });
    this.route('confirmation');
  });
  this.route('post-login', function () {
    this.route('index', { path: '/' });
    this.route('mfa-sms');
    this.route('terms');
  });
  this.route('redirect');
  this.route('pslf-employer', { path: 'pslf-employer/:form_document_id' }, function () {
    this.route('non-partner-verification');
    this.route('non-partner-sign');
  });

  if (ENV.environment === 'test') {
    this.route('test-start');
  }

  this.route('self-registration');

  this.route('authenticated', { path: '/' }, function () {
    // --------------------------------------------------------
    // --------------------------------------------------------
    // Employee routes
    // --------------------------------------------------------
    this.route('contact-us');
    this.route('dashboard');
    this.route('account-activity', function () {
      this.route('index', { path: '/' });
      this.route('accounts');
      this.route('loan-projections');
      this.route('new');
      this.route('loans', function () {
        this.route('detail', { path: '/:account_id' });
      });
    });

    this.route('pslf', function () {
      this.route('index', { path: '/' });
      this.route('dashboard', function () {
        this.route('start-new');
        this.route('recommendations');
        this.route('forgiveness-estimator', function () {
          this.route('index', { path: '/' });
          this.route('results', { path: ':recommendation_id' }, function () {
            this.route('index', { path: '/' });
            this.route('next-steps');
          });
        });
      });
      this.route('form', function () {
        this.route('success', { path: ':form_id/success' });
      });
      this.route('questions', function () {
        this.route('index');
        this.route('income-driven');
        this.route('teacher');
      });
    });
    this.route('repaying-student-debt', function () {
      this.route('index', { path: '/' });
      this.route('coaching', function () {
        this.route('index', { path: '/' });
        this.route('schedule');
      });
      this.route('repayment-strategy-finder', function () {
        this.route('index', { path: '/' });
        this.route('dashboard', function () {
          this.route('index', { path: '/' });
          this.route('recommendation-history');
          this.route('questionnaire', function () {
            this.route('index', { path: '/' });
            this.route('results', { path: ':recommendation_id' }, function () {
              this.route('index', { path: '/' });
              this.route('next-steps');
            });
          });
        });
      });
      this.route('loan-forgiveness', function () {
        this.route('index');
        this.route('income-driven');
        this.route('teacher');
      });
      this.route('repayment-options', function () {
        this.route('index', { path: '/' });
        this.route('refinancing');
      });
    });
    this.route('ten-twenty-cancellation');
    this.route('profile', function () {
      this.route('index', { path: '/' });
    });
    this.route('planning-for-college', function () {
      this.route('index', { path: '/' });
      this.route('scholarship');
      this.route('529-tools', function () {
        this.route('index');
        this.route('savings');
        this.route('faqs');
      });
    });
    this.route('questions-you-have', function () {
      this.route('index', { path: '/' });
      this.route('paying-for-college', function () {
        this.route('index', { path: '/' });
        this.route('private-loans');
        this.route('plus-loans');
      });
      this.route('repayment-plans', function () {
        this.route('index', { path: '/' });
        this.route('graduated');
        this.route('extended');
        this.route('income-driven');
      });
      this.route('repayment-options', function () {
        this.route('index', { path: '/' });
        this.route('refinancing');
      });
      this.route('loan-forgiveness', function () {
        this.route('index', { path: '/' });
        this.route('income-driven');
        this.route('teacher');
      });
      this.route('glossary');
    });
    this.route('idr', function () {
      this.route('index', { path: '/' });
      this.route('dashboard', function () {
        this.route('index', { path: '/' });
        this.route('recommendations');
        this.route('recommendation-history');
        this.route('forgiveness-estimator', function () {
          this.route('index', { path: '/' });
          this.route('results', { path: ':recommendation_id' }, function () {
            this.route('index', { path: '/' });
            this.route('next-steps');
          });
        });
      });
    });

    this.route('syf', function () {
      this.route('index', { path: '/' });
      this.route('account-confirmation');
      this.route('linking-confirmation', { path: 'linking-confirmation/:institution_id' });
      this.route('post-enrollment');
      this.route('enrollment');
      this.route('dashboard');
      this.route('payments', function () {
        // unused as of https://tuitionio.atlassian.net/browse/DEV-585 - james 2024-02-12
        // this.route('missing');
        this.route('new');
      });
      this.route('insights', function () {
        this.route('four-oh-one-k', { path: '401k' });
        this.route('idr');
        this.route('pslf');
      });
    });

    this.route('slr', function () {
      this.route('linking');
      this.route('linking-confirmation', { path: 'linking-confirmation/:institution_id' });
      this.route('dashboard');
    });

    this.route('observability', function () {
      this.route('upload');
      this.route('confirm', { path: 'documents/:observable_document_id/confirm' });
      this.route('dispute', { path: 'documents/:observable_document_id/dispute' });
      this.route('documents', function () {
        this.route('show', { path: ':observable_document_id' });
      });
    });

    this.route('tas', function () {
      this.route('dashboard-loading');
      this.route('dashboard');
      if (ENV.featureFlags?.newTasDashboard) {
        this.route('dashboard-v3');
        this.route('benefit-history');
      }
      this.route('confirmation');
      this.route('getting-started', {
        // essentially program-overview
        path: ':tas_program_template_id/getting-started',
      });

      this.route('programs-loading');
      this.route('programs', { path: 'programs/:tas_program_instance_id' }, function () {
        this.route('show');
        this.route('details');
        this.route('history');
        this.route('new');
      });

      // For now this is going to be very specific to Type 2 because normally we also have a program instance id
      this.route('applications-loading');
      this.route('applications', function () {
        this.route('show', { path: ':tas_application_id/show' });
        this.route('history', { path: ':tas_application_id/history' });
        this.route('type-two', function () {
          this.route('new', {
            path: ':tas_application_id/new',
          });
        });
        this.route('type-three', function () {
          this.route('new', {
            path: ':tas_application_id/new',
          });
        });
        this.route('type-four', function () {
          this.route('new', {
            path: ':tas_application_id/new',
          });
        });
      });
      this.route('dependent-programs');
      this.route('payments');
      this.route('mentoring');
    });

    this.route('lpn', function () {
      this.route('index', { path: '/' });
      this.route('show', { path: ':lpn_id' });
    });

    this.route('wellness-insights', function () {
      this.route('index', { path: '/' });
    });

    this.route('college-planning-mentors', function () {
      this.route('index', { path: '/' });
    });

    // --------------------------------------------------------
    // Career Pathways routes (DEMO)
    // --------------------------------------------------------
    this.route('reimagined', function () {
      this.route('home'); // Reimagined landing page demo
      this.route('index', { path: '/' });
      this.route('explore', function () {
        this.route('index', { path: '/' });
        this.route('role', { path: ':role_id' });
        this.route('compare');
      });
      this.route('skills', function () {
        this.route('index', { path: '/' });
        this.route('assessment');
        this.route('gaps');
      });
      this.route('recommendations');
      this.route('plan', function () {
        this.route('index', { path: '/' });
        this.route('new');
        this.route('roadmap');
        this.route('strategy', function () {
          this.route('index', { path: '/' });
        });
        this.route('advisor', function () {
          this.route('index', { path: '/' });
        });
      });
      this.route('advisor');
      this.route('success-stories');
      // Financial & Engagement Features (new)
      this.route('finance', function () {
        this.route('index', { path: '/' });
        this.route('optimizer');
        this.route('history');
      });
      this.route('loans', function () {
        this.route('index', { path: '/' });
        this.route('detail', { path: '/:account_id' });
      });
      this.route('benefits', function () {
        this.route('index', { path: '/' });
      });
      this.route('tas', function () {
        this.route('index', { path: '/' });
        this.route('dashboard');
        this.route('programs', function () {
          this.route('index', { path: '/' });
          this.route('show', { path: ':tas_program_instance_id/show' });
          this.route('details', { path: ':tas_program_instance_id/details' });
          this.route('history', { path: ':tas_program_instance_id/history' });
          this.route('new', { path: ':tas_program_instance_id/new' });
        });
        this.route('applications', function () {
          this.route('index', { path: '/' });
          this.route('show', { path: ':tas_application_id/show' });
          this.route('history', { path: ':tas_application_id/history' });
          this.route('type-two', function () {
            this.route('new', { path: ':tas_application_id/new' });
          });
          this.route('type-three', function () {
            this.route('new', { path: ':tas_application_id/new' });
          });
          this.route('type-four', function () {
            this.route('new', { path: ':tas_application_id/new' });
          });
        });
      });
      // LRAP Features
      this.route('lrap', function () {
        this.route('index', { path: '/' }); // LRAP Discovery
      });
      // PSLF Reimagined - The Forgiveness Accelerator
      this.route('pslf', function () {
        this.route('index', { path: '/' }); // Main PSLF Dashboard
        this.route('payments', function () {
          this.route('index', { path: '/' }); // Payment validation grid
          this.route('detail', { path: '/:payment_id' }); // Individual payment proof
        });
        this.route('certifications', function () {
          this.route('index', { path: '/' }); // ECF history
          this.route('generate'); // Smart ECF builder
        });
        this.route('vault'); // Document storage (port from pslf-vault)
        this.route('timeline'); // Visual journey
        this.route('milestones'); // Achievement tracking
        this.route('scenarios', function () {
          this.route('index', { path: '/' }); // Scenario overview
          this.route('leave'); // Leave public service
          this.route('employer'); // Change employer
          this.route('plan'); // Change repayment plan
        });
        this.route('policy'); // Policy monitor
        this.route('celebrate', { path: '/celebrate/:milestone_id' }); // Milestone celebration
      });
      this.route('pslf-vault', function () {
        this.route('index', { path: '/' }); // PSLF Compliance Vault (legacy)
      });
      this.route('onboarding', function () {
        this.route('index', { path: '/' }); // Smart Onboarding Flow
      });
      this.route('score'); // Career Capital Score
      this.route('components', function () {
        // UI Pattern showcase (demo only)
        this.route('index', { path: '/' }); // Component catalog grid
        this.route('select'); // Select / Multi-Select / Remote Search
        this.route('drawer'); // Drawer (placement, sizes, portaled)
        this.route('cards'); // ActionableCard, HighlightCard, GlassCard, StepCard
        this.route('feedback'); // AlertBanner, EmptyState, IconBadge, FaqAccordion
        this.route('data-display'); // StatCard, ProgressBar, PipelineFlow, Timeline, InfoRow
        this.route('navigation'); // PageHero, NavCard, SectionHeader, SectionPanel
        this.route('patterns'); // FilterTabs, MatchScoreBadge, SkillChip, StatusBadge, TaEligibilityBadge
        this.route('forms'); // Input, Textarea, Checkbox, RadioGroup, Switch, SearchInput, Form
        this.route('buttons'); // Button — reimagined, zero-Frontile button
        this.route('chips'); // Chip — reimagined, zero-Frontile chip / badge
        this.route('charts'); // Chart — native Canvas/SVG charts (replaces Vega)
        this.route('gradients'); // Gradient utilities — Figma-driven branded backgrounds
      });
      // Coaching & Help Resources (reimagined)
      this.route('coaches', function () {
        this.route('index', { path: '/' }); // Expert loan coaches
      });
      this.route('glossary', function () {
        this.route('index', { path: '/' }); // Financial terms glossary
      });
      // Income-Driven Repayment reimagined
      this.route('idr', function () {
        this.route('index', { path: '/' });
      });
      // Save Your Future (retirement/401k)
      this.route('syf', function () {
        this.route('index', { path: '/' });
      });
      // Profile & Settings
      this.route('profile');
      // Documents & Observability
      this.route('documents', function () {
        this.route('index', { path: '/' });
      });
      // Contact Us
      this.route('contact');
      // College Planning (529, scholarships)
      this.route('college-planning', function () {
        this.route('index', { path: '/' });
      });
      // Financial Wellness
      this.route('wellness');
      // Learning Partner Network
      this.route('lpn', function () {
        this.route('index', { path: '/' });
      });
      this.route('admin', function () {
        this.route('index', { path: '/' });
        this.route('team');
        this.route('skills-inventory');
        this.route('leadership');
        this.route('pipeline-report');
        this.route('program-effectiveness');
      });
    });

    // --------------------------------------------------------
    // Admin routes
    // --------------------------------------------------------
    this.route('admin', function () {
      this.route('plans', { path: 'plans/:company_id' });
      this.route('employees', function () {
        this.route('index', { path: '/' });
        this.route('show', { path: ':employee_id' });
        this.route('add');
      });
      this.route('eligibility-files', function () {
        this.route('index', { path: '/' });
        this.route('show', { path: ':eligibility_file_job_log_id' });
      });
      this.route('reports', function () {
        this.route('index', { path: '/' });
        this.route('show', { path: ':quicksight_dashboard_id' });
      });
      this.route('pslf', function () {
        this.route('forms', { path: '/' });
        this.route('sign');
        this.route('form', function () {
          this.route('sign', { path: ':form_id/sign' });
          this.route('review', { path: ':form_id/review' });
          this.route('success', { path: ':form_id/success' });
        });
      });

      // TAS routes - approval route only available in non-production environments
      this.route('tas', function () {
        if (ENV.featureFlags?.newTasApprovalUx) {
          this.route('applications', function () {
            this.route('index', { path: '/' });
            this.route('approval', { path: ':tas_application_id/approval' });
          });
        }
        this.route('approval-queue');
      });

      this.route('tuition-assistance', function () {
        this.route('dashboard');
        this.route('payments');
        this.route('program-templates', function () {
          this.route('show', { path: ':tas_program_template_id' });
        });
        this.route('applications', function () {
          this.route('show', { path: ':tas_application_id' }, function () {
            this.route('index', { path: '/' });
            this.route('messages');
            this.route('readonly');
          });
        });
        this.route('program-instances', function () {
          this.route('index', { path: '/' });
          this.route('show', { path: ':tas_program_instance_id' }, function () {
            this.route('index', { path: '/' });
            this.route('messages');
            this.route('readonly');
          });
        });
      });
      this.route('people', function () {
        this.route('show', { path: ':person_id' });
      });
      this.route('reporting', function () {
        this.route('index', { path: '/' });
        this.route('tas-payables');
        this.route('tas-payments');
        this.route('tas-applications');
        this.route('tas-programs');
      });
    });
  });
  this.route('not-found', { path: '/*' });
});
